import axios from 'axios';
// import { useAuth } from '../../contexts/AuthContext';


export const user = {
  getMyUsers: async (caraUser) => {
    const API_URL = process.env.REACT_APP_API_URL;
    try {
      const response = await axios.get(`${API_URL}api/Create-users/`, {
        withCredentials: true,
      });
      if (response.status === 200 && response.data.status === 'SUCCESS') {
        const users = response.data.users || [];

        // Return all CARA users - let each framework filter as needed
        return users;
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
    return [];
  },

  getAllUsers: async (caraUser) => {
    const API_URL = process.env.REACT_APP_API_URL;
    try {
      const response = await axios.get(`${API_URL}api/Create-users/`, {
        withCredentials: true,
      });
      if (response.status === 200 && response.data.status === 'SUCCESS') {
        const users = response.data.users || [];
        return users;
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
    return [];
  },
};